import React from 'react';
import { Tag, Typography } from 'antd';
import { JobApplication } from '../models/job-application.model';
import StagesTimeline from './StagesTimeline';
import InterviewPanel from './InterviewPanel';

interface PipelineRailProps {
  application: JobApplication;
  statuses: string[];
  companyId?: string;
  onStageChanged: () => Promise<void>;
}

function currentStageName(application: JobApplication): string {
  const stages = application.jobApplicationStatuses || [];
  if (stages.length === 0) return application.status || 'No stage';
  const latest = stages[stages.length - 1];
  return latest?.statusName?.replace(/_/g, ' ') || application.status || 'No stage';
}

const PipelineRail: React.FC<PipelineRailProps> = ({
  application,
  statuses,
  companyId,
  onStageChanged,
}) => {
  const stageLabel = currentStageName(application);

  return (
    <aside
      className="application-panel pipeline-rail"
      aria-label="Pipeline and interviews"
    >
      <div className="pipeline-rail__header">
        <div>
          <Typography.Title level={4} className="!mb-0 !text-base">
            Pipeline
          </Typography.Title>
          <Typography.Text type="secondary" className="text-xs">
            Activity and next steps
          </Typography.Text>
        </div>
        <Tag color="processing" className="m-0">
          {stageLabel}
        </Tag>
      </div>

      <section aria-label="Stages timeline" className="pipeline-rail__timeline">
        <StagesTimeline
          data={application.jobApplicationStatuses}
          applicationId={application.id}
          statuses={statuses}
          clientId={application.job?.client?.id}
          companyId={companyId}
          onAddStage={onStageChanged}
          application={application}
        />
      </section>

      <div className="pipeline-rail__interviews" aria-label="Interviews">
        {application.id ? (
          <InterviewPanel
            jobApplicationId={application.id}
            disabled={Boolean(application.closed || application.deleted)}
          />
        ) : null}
      </div>
    </aside>
  );
};

export default PipelineRail;
